import React, {
  useEffect,
  useState,
} from 'react';

import { commonAPI } from 'api/commonAPI';
import Business from 'assets/images/icon/Business';
import Career from 'assets/images/icon/Career';
import Check from 'assets/images/icon/Check';
import Finance from 'assets/images/icon/Finance';
import Lifestyle from 'assets/images/icon/Lifestyle';
import Mindset from 'assets/images/icon/Mindset';
import { cloneDeep } from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { instructorApp } from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import axios from "axios";

const returnIcon = (category) => {
    switch (category) {
        case "BUSINESS": {
            return <Business />;
        }
        case "FINANCE": {
            return <Finance />;
        }
        case "CAREER": {
            return <Career />;
        }
        case "MINDSET": {
            return <Mindset />;
        }
        case "LIFESTYLE": {
            return <Lifestyle />;
        }
        default: {
            return "";
        }
    }
};

const Step2 = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [renderItem, setRenderItem] = useState(false);
    const [instructorData, setInstructorData] = useRecoilState(instructorApp);
    const [category, setCategory] = useState<[string, any[]][]>([]);
    const [dropDownList, setDropDownList] = useState([]);
    const [topics, setTopics] = useState([]);
    const getCategory = async () => {
        const result = await commonAPI.getCategory(null).then((res) => {
            return res?.data;
        });

        if (!isEmpty(result)) {
            let copy = cloneDeep(result);
            let obj = {};
            copy.forEach((item: any) => {
                if (obj[item.category] === undefined) {
                    obj[item.category] = [];
                }
                obj[item.category].push(item);
            });
            setCategory(Object.entries(cloneDeep(obj)));
        }
    };

    const returnData = (categoryItem: string) => {
        if (isEmpty(category)) {
            return {
                category: "",
                categoryList: [],
            };
        }
        const copy = cloneDeep(category);
        const findItem = copy?.find((item) => item[0] === categoryItem);
        return {
            category: findItem ? findItem[0] : "",
            categoryList: findItem ? findItem[1] : [],
        };
    };

    const dropDownCheck = (item, state, setState, idCheck = false) => {
        const copy = cloneDeep(state);
        let index;
        if (idCheck) {
            index = copy.findIndex((findItem) => findItem?.id === item?.id);
        } else {
            index = copy.findIndex((findItem) => findItem === item);
        }
        if (index === -1) {
            copy.push(item);
        } else {
            copy.splice(index, 1);
        }
        setState(copy);
        return index;
    };

    const onClickNavigate = (path) => {
        let state;
        if(!isEmpty(location?.state?.step3)){
            state = {
                step1: location?.state?.step1,
                step2: cloneDeep(topics),
                step3: location?.state?.step3,
            }
        }else{
            state = {
                step1: location?.state?.step1,
                step2: cloneDeep(topics),
            }
        }
        navigate(path, {
            state: cloneDeep(state)
        });
    };

    console.log("location", location.state);

    useEffect(() => {
        getCategory();
    }, []);

    useEffect(() => {
        return () => {
            setInstructorData(cloneDeep({ ...location?.state?.step1 }));
        };
    }, []);

    useEffect(()=>{
        if(!isEmpty(location?.state?.step2)){
            setTopics(cloneDeep(location?.state?.step2))
        }
    },[location?.state?.step2])

    useEffect(()=>{
        setTimeout(() => {
        setRenderItem(true)            
        }, 250);
    },[])

    let Array;

    const DataArray = ["BUSINESS", "FINANCE", "CAREER", "MINDSET", "LIFESTYLE"];

    console.log("props", props);

    if (!isEmpty(category)) {
        Array = DataArray?.map((item) => {
            return returnData(item);
        });
    }

    return (
        <Container
        className={renderItem ? "on" : ""}
        >
            <SubTitle>
                <h2>2. Topics</h2>
            </SubTitle>
            <SubText>
                Please select topics for your class or coaching. You can choose up to three topics
                in each field.
            </SubText>
            <DropDownContents>
                {Array?.map((item, index) => {
                    return (
                        <DropDownWrap
                            style={{
                                height:
                                    dropDownList.findIndex(
                                        (findItem) => findItem === item?.category
                                    ) === -1
                                        ? 68
                                        : item?.categoryList?.length * 47 + 88,
                                overflowY:
                                    dropDownList.findIndex(
                                        (findItem) => findItem === item?.category
                                    ) === -1
                                        ? "hidden"
                                        : "hidden",
                            }}
                        >
                            <DropDownHeader
                                onClick={() => {
                                    dropDownCheck(item?.category, dropDownList, setDropDownList);
                                }}
                                className="accordion__title-text"
                            >
                                <h3>
                                    {returnIcon(item?.category)}
                                    {item?.category}
                                </h3>
                                <BorderWrap
                                    className={
                                        dropDownList.findIndex(
                                            (findItem) => findItem === item?.category
                                        ) === -1
                                            ? ""
                                            : "isOpen"
                                    }
                                >
                                    <Border1 />
                                    <Border2 />
                                </BorderWrap>
                            </DropDownHeader>
                            <DropDownList
                                style={{
                                    opacity:
                                        dropDownList.findIndex(
                                            (findItem) => findItem === item?.category
                                        ) === -1
                                            ? 1
                                            : 1,
                                }}
                            >
                                {item?.categoryList?.map((subItem) => {
                                    return (
                                        <DropDownListItem
                                            className={
                                                topics?.findIndex(
                                                    (findItem) => findItem?.id === subItem?.id
                                                ) === -1
                                                    ? ""
                                                    : "on"
                                            }
                                            onClick={() => {
                                                dropDownCheck(subItem, topics, setTopics, true);
                                            }}
                                        >
                                            <CheckBoxWrap
                                                className={
                                                    topics?.findIndex(
                                                        (findItem) => findItem?.id === subItem?.id
                                                    ) === -1
                                                        ? ""
                                                        : "on"
                                                }
                                            >
                                                <div>
                                                    <Check />
                                                </div>
                                            </CheckBoxWrap>
                                            <span>{subItem?.subCategory}</span>
                                        </DropDownListItem>
                                    );
                                })}
                            </DropDownList>
                        </DropDownWrap>
                    );
                })}
            </DropDownContents>
            <Btns>
                <Next>
                    <span
                        onClick={() => {
                            onClickNavigate("/instructor_application/step1");
                        }}
                        style={{ background: "#000" }}
                    >
                        PREVIOUS
                    </span>
                </Next>
                <Next>
                    <span
                        onClick={() => {
                            onClickNavigate("/instructor_application/step3");
                        }}
                    >
                        NEXT
                    </span>
                </Next>
            </Btns>
        </Container>
    );
};
export default Step2;

const Container = styled.div`
  display: block;
     transform: translateX(-50px);
    transition: all 0.25s;
    opacity: 0;
    height: 300px;
        &.on{
    height: auto;

        opacity: 1;
        transform: none;
    }
    p {
        font-family: Arial;
        font-weight: 400;
        font-size: 14px;
        color: #666;
        line-height: 21px;
    }
`;
const SubTitle = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 17px;
    h2 {
        font-size: 20px;
        font-weight: 400;
        font-weight: 400;
        color: #333;
    }
    span {
        display: flex;
        color: #666;
        font-size: 12px;
    }
`;
const SubText = styled.h3`
    font-family: Arial, sans-serif;
    font-size: 16px;
    margin-bottom: 24px;
    color: #333;
    font-weight: 400;
    line-height: 21px;
`;
const Btns = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div {
        width: calc((100% - 8px) / 2);
    }
`;
const Next = styled.div`
    span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Arial;
        font-weight: 700;
        font-size: 15px;
        text-align: center;
        text-transform: uppercase;
        color: #fff;
        background: #e0c463;
        border-radius: 5px;
        width: 100%;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        border: 0;
        padding: 17.68px 12px;
        cursor: pointer;
    }
`;
const DropDownContents = styled.div`
    transition: all 0.3s;
    margin-bottom: 30px;
`;
const DropDownHeader = styled.div`
    border-top: 1px solid #ccc;
    padding: 17.5px 0;
    cursor: pointer;
    font-size: 18px;
    font-weight: 700;
    position: relative;
    h3 {
        display: flex;
        align-items: center;
    }
    svg {
        margin-right: 10px;
    }
    display: flex;
    align-items: center;
`;
const BorderWrap = styled.div`
    position: absolute;
    pointer-events: none;
    transform: translateX(-16px);
    right: 0;
    height: 100%;
    width: 300px;
    transition: all 0.3s;
`;
const Border1 = styled.div`
    transition: all 0.3s;
    width: 2px;
    background: #333;
    position: absolute;
    top: 50%;
    height: 12px;
    right: 0;
    transform: rotate(-45deg) translateY(-50%) translateX(11.5px);
    .isOpen & {
        transform: rotate(45deg) translateY(-50%) translateX(-0.5px);
    }
`;
const Border2 = styled.div`
    transition: all 0.3s;
    width: 2px;
    background: #333;
    position: absolute;
    top: 50%;
    height: 12px;
    right: 0;

    .isOpen & {
        transform: rotate(-45deg) translateY(-50%) translateX(0.5px);
    }
    transform: rotate(45deg) translateY(-50%);
`;
const DropDownWrap = styled.div`
    transition: all 0.3s;
`;
const DropDownList = styled.div`
    padding: 10px 0;
    transition: all 0.3s;
`;
const DropDownListItem = styled.div`
    cursor: pointer;
    transition: all 0.2s;
    padding: 0 2px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    font-size: 16px;
    color: #666;
    &.on {
        font-weight: 700;
    }
`;

const CheckBoxWrap = styled.div`
    display: flex;
    align-items: center;
    transition: all 0.2s;
    padding-bottom: 2px;
    margin-right: 13px;
    cursor: pointer;
    &.on {
        transition: all 0.2s;
        svg {
            transform: scale(1.3);
        }
        & > div {
            transition: all 0.2s;
            border: solid 1px #ddc160;
            background: #ddc160;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    span {
        padding-top: 2px;
        font-size: 16px;
        color: #212529;
    }
    div {
        width: 25px;
        height: 25px;
        border-radius: 4px;
        border: solid 1px rgba(51, 51, 51, 0.3);
    }
`;
